import React from "react";
import { userStore } from "users/_stores/userStore";
import { observer } from "mobx-react";
import { X } from "lucide-react";

export const UserSelectedOverlay = observer(() => {
    return (
        <div
            className={
                "text-white bg-blue-400 absolute flex items-center justify-center w-full bottom-0 right-0 left-0 z-[1100]"
            }
        >
            {userStore.userSelected && (
                <div className={"py-4 flex flex-row"}>
                    <span>
                        {userStore.userSelected.name} - {userStore.userSelected.email}
                    </span>
                    <span
                        className={"cursor-pointer absolute right-2"}
                        onClick={() => {
                            userStore.setUserSelected(undefined);
                        }}
                    >
                        <X />
                    </span>
                </div>
            )}
        </div>
    );
});
